import { Button, Grid, Typography } from '@material-ui/core';
import laqusImf from 'assets/laqus-imf-digital-1x.png';
import { funcaoParticipanteDescriptions } from 'common/genericDescriptions';
import { ParticipanteAuthResponse } from 'common/genericTypes';
import { FuncaoCard } from 'components/avatarMenu/funcaoCard';
import { MdSpace, SmSpace } from 'm2m.components';
import React, { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { login } from 'store/modules/auth';
import _ from 'lodash';

const mapDispatchToProps = { login };

type Props = typeof mapDispatchToProps;

const EscolherFuncao: React.FC<Props> = (props) => {
  const { login } = props;
  const usuarioApi = useSelector((state: RootState) => state.usuarioApi);
  const dispatch = useDispatch();

  const [funcoes, setFuncoes] = useState<ParticipanteAuthResponse[]>([]);
  const [selectedFuncao, setSelectedFuncao] = useState<ParticipanteAuthResponse>();

  const handleLogin = async () => {
    try {
      if (selectedFuncao) {
        const result = await usuarioApi.login(dispatch, selectedFuncao?.participanteFuncaoUsuarioId);
        login({
          usuario: { ...result, participanteFuncaoUsuarioId: selectedFuncao?.participanteFuncaoUsuarioId },
          token: result.token,
        });
        history.go(0);
      }
    } catch (error) {}
  };

  const getFuncoes = useCallback(async () => {
    try {
      const result = await usuarioApi.getFuncoes(dispatch, true);
      setFuncoes(result);
    } catch { }
  }, []);

  useEffect(() => {
    getFuncoes();
  }, []);


  return (
    <Grid container justify="center">
      <Grid item>
        <img src={laqusImf} alt="Logo Laqus IMF digital" />
      </Grid>
      <Grid item sm={10}>
        <MdSpace />
        <Typography align="center" variant="h2">
          {`Seja bem-vindo!`}
        </Typography>
        <MdSpace />
        <Typography align="center" variant="body2">
          {`Escolha a função que deseja para iniciar seu acesso.`}
        </Typography>
        <MdSpace />
        {_.orderBy(funcoes, [(funcao) => funcao.razaoSocial, (funcao) => funcao.funcao]).map((funcao) => (
          <React.Fragment key={funcao.participanteFuncaoUsuarioId}>
            <FuncaoCard
              selected={selectedFuncao?.participanteFuncaoUsuarioId === funcao.participanteFuncaoUsuarioId}
              onClick={() => setSelectedFuncao(funcao)}
              title={funcaoParticipanteDescriptions[funcao.funcao]}
              description={funcao.razaoSocial}
              dataTestId={`btnFuncao${_.upperFirst(_.camelCase(funcao.funcao))}`}
            />
            <SmSpace />
          </React.Fragment>
        ))}
      </Grid>
      <Grid item>
        <Button
          disabled={!selectedFuncao}
          variant="contained"
          color="primary"
          style={{ margin: '0', padding: '16px 60px' }}
          onClick={handleLogin}
          data-TestId="btnFuncaoContinuar"
        >
          {'Continuar'}
        </Button>
      </Grid>
    </Grid>
  );
};

export default connect(null, mapDispatchToProps)(EscolherFuncao);
